module.exports = __webpack_public_path__ + "static/semantic-placeholder-content-lines-846ae94635cfd1568f598b10a89974d1.gif";